import { createAsyncThunk } from '@reduxjs/toolkit';

import * as VirtualApi from '../../api/virtual';

export const loadVirtualMemberships = createAsyncThunk(
  'virtual/memberships/load',
  async (queryParams, { rejectWithValue }) => {
    try {
      const data = await VirtualApi.fetchVirtualMemberships(queryParams);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const loadAutoShares = createAsyncThunk('virtual/autoshares/load', async (queryParams, { rejectWithValue }) => {
  try {
    const data = await VirtualApi.fetchAutoShares(queryParams);
    return data;
  } catch (e) {
    return rejectWithValue(e.response.data);
  }
});

export const createAutoShares = createAsyncThunk('virtual/autoshares/create', async (data, { rejectWithValue }) => {
  try {
    const response = await VirtualApi.postAutoShares(data);
    return response;
  } catch (e) {
    return rejectWithValue(e.response.data);
  }
});

export const removeAutoShares = createAsyncThunk('virtual/autoshares/remove', async (ids, { rejectWithValue }) => {
  try {
    const response = await VirtualApi.deleteAutoShares(ids);
    return response;
  } catch (e) {
    return rejectWithValue(e.response.data);
  }
});

export const shareVirtualAccess = createAsyncThunk('virtual/share', async (signatures, { rejectWithValue }) => {
  try {
    const data = await VirtualApi.postShareVirtualAccess(signatures);
    return data;
  } catch (e) {
    return rejectWithValue(e.response.data);
  }
});

export const unshareVirtualAccess = createAsyncThunk('virtual/unshare', async (signatures, { rejectWithValue }) => {
  try {
    const data = await VirtualApi.postUnshareVirtualAccess(signatures);
    return data;
  } catch (e) {
    return rejectWithValue(e.response.data);
  }
});
